import React, { Fragment, useState } from 'react';
import { Paper, Container, Grid, Box, CssBaseline, Button, Typography, TextField, InputAdornment, Slide } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useBackdrop, openBackdrop } from '../hooks/useBackdrop';
import { useNavigate } from 'react-router-dom';
import Stack from "@mui/material/Stack";
import MobileDateTimePicker from "@mui/lab/MobileDateTimePicker";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";

export default function Playground() {

  return (
    <Box padding={2}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Stack spacing={2}>
          <Simple />
        </Stack>
      </LocalizationProvider>
    </Box>
  );
}

const Simple = () => {
  const [value, setValue] = useState(new Date());

  // Copy value to selectedValue, used as temporary Picker value until accepted
  // Replace with useEffect when value is provided as prop and can change from a different source
  const [selectedValue, setSelectedValue] = useState(value);

  // Use a random key for the picker each time it opens, forcing it to re-render and update its internal value state
  const [pickerKey, setPickerkey] = useState(0);

  // Only update value when the user clicks OK
  const onAccept = (value) => {
    console.log('Accept')
    setValue(selectedValue);
  };

  // Required to keep the visible Picker state in sync
  const onChange = (value) => {
    setSelectedValue(value);
  };

  // Generate a new random picker key when the picker is closed
  const onClose = (event) => {
    // Replace with an actual random value :P
    setPickerkey(Math.floor(Math.random() * 20));
  };

  return (
    <Fragment key={`picker-${pickerKey}`}>
      <MobileDateTimePicker
        label="Mobile picker"
        renderInput={(props) => <TextField {...props} />}
        value={value}
        onAccept={onAccept}
        onChange={onChange}
        onClose={onClose}
      />
    </Fragment>
  );
};
